export enum EQuantityTypesLow {
  NoQuantity = "no quantity",
  QuantityAsMultiplierBadSpelling = "quantity as multiplier bad spelling",
  QuantityAsMultiplier = "quantity as multiplier",
  QuantityAsDivider = "quantity as divider",
  QuantityAsValue = "quantity as value",
  QuantityAsSubtract = "quantity as subtract",
}
